import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const ApiKeySelectorModal = ({ open, onClose, onSelect }) => {
  const [apiKeys, setApiKeys] = useState([]);
  const [selectedKeyId, setSelectedKeyId] = useState("");

  useEffect(() => {
    if (open) {
      (async () => {
        try {
          const { data } = await api.get("/apikey");
          setApiKeys(Array.isArray(data) ? data : data.apiKeys || []); 
        } catch (err) {
          toastError(err);
        }
      })();
    }
  }, [open]);

  const handleConfirm = () => {
    const selected = Array.isArray(apiKeys) ? apiKeys.find(k => k.id === selectedKeyId) : null;
    if (selected) {
      onSelect(selected.id);
      onClose();
    } else {
      toastError("Selecione uma chave válida.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("assistant.modal.selectApiKeyTitle")}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel>{i18n.t("assistant.modal.apiKeyLabel")}</InputLabel>
          <Select
            value={selectedKeyId}
            onChange={(e) => setSelectedKeyId(e.target.value)}
          >
            {apiKeys.map((key) => (
              <MenuItem key={key.id} value={key.id}>
              {`${key.name} - ${key.key}`}
            </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          {i18n.t("assistant.buttons.cancel")}
        </Button>
        <Button onClick={handleConfirm} color="primary" disabled={!selectedKeyId}>
          {i18n.t("assistant.buttons.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApiKeySelectorModal;
